import CustomersContainer from './CustomersContainer';
export default CustomersContainer;
